import {Component, OnInit, Input} from '@angular/core';
import {Router} from "@angular/router";
import {SupplierBaseService} from "../../../routes/jy-srm/supplier/supplier-base/supplier-base.service";

@Component({
  selector: 'sup-detail-link',
  template: `<span (click)="jumpTo()" style="cursor: pointer;">
   {{showValue}}
    <i nz-icon [class]="icon" [ngStyle]="{'color':this.color}"></i>
  </span>`
})
export class SupDetailLinkComponent implements OnInit {
  //展示的值
  @Input() showValue;
  //供应商id
  @Input() supplierId;
  //跳转地址code值
  @Input() code;
  //是否可编辑
  @Input() isEdit;
  @Input() icon;
  @Input() color;
//是否为供应商引导页跳转的
  @Input() guideBol;

  /**
   * code对应的路由地址
   */

  public codeRouterUrl = {
    'code1':'/base-info',//基本信息
    'code2':'/manage',//管理信息
    'code3':'/procure-organ',//采购组织
    'code4':'/company',//公司
    'code5':'/supply-category',//供应商品（供应品类）
    'code6':'/supply-category',//供应商品（产品其它信息）
    'code7':'/address',//地址
    'code8':'/contact',//联系人
    'code9':'/certificate',//证件资质
    'code10':'/invoice',//开票信息
    'code11':'/bank',//银行
    'code12':'/operat-condit',//经营情况
    'code13':'/product-ability',//技产能力
    'code14':'/agent-infor',//代理信息
    'code15':'/reserved-one',//预留类型1
    'code16':'/reserved-two',//预留类型2
    'code17':'/reserved-three',//预留类型3
    'code18':'/reserved-four',//预留类型4
    'code19':'/reserved-five',//预留类型5
  };

  jumpTo() {



    this.supplierBaseService.get(this.supplierId).subscribe((data)=>{
      this.questionaryId = data.questionaryId;
      if(this.supplierId && this.questionaryId){
        let obj:any = {supplierId: this.supplierId, questionaryId: this.questionaryId};
        if(this.guideBol){
          obj.guidePage = true;
        }
        if(this.code){
          if(this.isEdit){
            this.router.navigate(['/supplier-view/' + this.supplierId + '/0' + this.codeRouterUrl['code'+this.code], {searchData: JSON.stringify(obj)}]);
          }else{
            this.router.navigate(['/supplier-view/' + this.supplierId + '/1' + this.codeRouterUrl['code'+this.code] + '/view', {searchData: JSON.stringify(obj)}]);
          }
        }else{
          if(this.isEdit){
            this.router.navigate(['/supplier-view/' + this.supplierId + '/0/base-info', {searchData: JSON.stringify(obj)}]);
          }else{
            this.router.navigate(['/supplier-view/' + this.supplierId + '/1/base-info/view', {searchData: JSON.stringify(obj)}]);
          }
        }
      }
    });
  }

  //获取供应商调查表id
  public questionaryId;
  constructor(private router:Router,private supplierBaseService:SupplierBaseService) {
  }

  ngOnInit() {

  }


}
